import React, { useEffect, useState } from 'react';

import { Button } from 'shadcn/components/ui/Button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from 'shadcn/components/ui/Dialog';

import { ReasonCodePicker } from './formComponents/ReasonCodePicker';

export function ReasonCodeDialog({
    isSubmitting = false,
    onCancel,
    onConfirm,
    open,
    title = 'Select A Reason Code and Confirm',
}) {
    const [selectedReasonCode, setSelectedReasonCode] = useState('');

    useEffect(() => {
        if (open) {
            setSelectedReasonCode('');
        }
    }, [open]);

    const handleOpenChange = (nextOpen) => {
        if (isSubmitting) return;
        if (!nextOpen && typeof onCancel === 'function') {
            onCancel();
        }
    };

    const handleConfirm = () => {
        if (!selectedReasonCode || isSubmitting) return;
        if (typeof onConfirm === 'function') {
            onConfirm(selectedReasonCode);
        }
    };

    return (
        <Dialog open={open} onOpenChange={handleOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                </DialogHeader>
                <div className="py-2">
                    <ReasonCodePicker value={selectedReasonCode} onValueChange={setSelectedReasonCode} />
                </div>
                <DialogFooter>
                    <Button type="button" variant="outline" onClick={onCancel} disabled={isSubmitting}>
                        Cancel
                    </Button>
                    <Button type="button" onClick={handleConfirm} disabled={!selectedReasonCode || isSubmitting}>
                        Confirm
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

ReasonCodeDialog.displayName = 'ReasonCodeDialog';
